import { Middleware } from "redux";
import { IChat } from "types/IChat";
import * as actions from "../socket";
import ReconnectingWebSocket from "reconnecting-websocket";
import { loadChats } from "stores/chats/chats";
import { loadCannedResponses } from "stores/chats/cannedResponses";
import {
  loadChatConfigurations,
  loadBusinessHoursChatPermission,
  updateLockCondition
} from "stores/chats/chatConfigurations";
import { updateChatDeliveryStatus } from "stores/chats/chats";
import { userTyping } from "stores/chats/typing";
// import { useDispatch, useSelector } from "react-redux";
import { viewFor } from "utils/constants";
import { loadChatInfo } from "stores/chats/chatInfo";

const agentRole = "agent";

const SOCKET_URL: string =
  process.env.REACT_APP_CHATAPP_SOCKET_URL ||
  "wss://4l7xb4day3.execute-api.ap-south-1.amazonaws.com/beta";
export let ws: ReconnectingWebSocket | undefined;

let intervalId: ReturnType<typeof setInterval>;

const socket: Middleware<{}, IChat> =
  ({ dispatch, getState }) =>
  (next) =>
  async (action) => {
    if (action.type === actions.wsconnect.type) {
      if (!action.payload.chatId) {
        return;
      }

      // if(ws) {
      //     ws.close();
      // }

      ws = new ReconnectingWebSocket(
        `${SOCKET_URL}/?chatId=${action.payload.chatId}&connectType=${viewFor}`,
        [],
        {
          connectionTimeout: 20000,
          maxReconnectionDelay: 10000,
          minReconnectionDelay: 1000 + Math.random() * 2000,
          reconnectionDelayGrowFactor: 1.4,
          minUptime: 200,
          debug: true
        }
      );

      ws.addEventListener("open", (event) => {
        // console.log("onOpen", event);

        intervalId = setInterval(() => {
          // console.log('WS Ready State:', ws?.readyState);
        }, 5000);
      });

      ws.addEventListener("close", (event) => {
        // console.log("onClose", event);
      });

      ws.addEventListener("error", (event) => {
        // console.log("websocket error", event);
      });

      ws.onmessage = (event) => {
        // console.log('ws::event', event)
        const eventData = JSON.parse(event.data) || {};
        switch (eventData.type) {
          case "fetchMessages":
            fetchMessagesCB(
              dispatch,
              action.payload.chatId,
              action.payload.currentUser,
              agentRole
            );
            break;
          case "fetchNotes":
            if (action.payload.currentUser?.type === agentRole) {
              dispatch(loadChats({ chatId: action.payload.chatId }));
            }
            break;
          case "fetchSuggestions":
            if (action.payload.currentUser?.type === agentRole) {
              dispatch(loadCannedResponses(action.payload.currentUser.id));
            }
            break;
          case "debug-connect":
            localStorage.setItem(eventData.chatId, eventData.connectionId);
            break;
          case "messageDelieveryFailed":
            if (action.payload.currentUser?.type === agentRole) {
              window.parent.postMessage({
                type: "showToast",
                msgType: "error",
                errorMsg: eventData.errorMsg || "Message delievery failed"
              });
            }
            break;
          case "deliveryStatus":
            dispatch(updateChatDeliveryStatus(eventData.payload));
            break;
          case "typing":
            dispatch(userTyping(eventData));
            break;
          case "checkLockCondition":
            dispatch(updateLockCondition(eventData.value));
            break;
          case "getChatInfo":
            const chatId = action.payload.chatId;
            new Promise((resolve, reject) => {
              dispatch(
                loadChatInfo({
                  chatId,
                  resolve,
                  reject
                })
              );
            });
            break;
          default:
            break;
        }
      };
    } else if (action.type === actions.wssend.type) {
      if (ws) {
        ws.send(action.payload);
      } else {
        // console.log('sokect is not initialized');
      }
    } else if (action.type === actions.wsdisconnect.type) {
      if (ws) {
        ws.close();
      } else {
        // console.log('sokect is not initialized');
      }
    } else {
      next(action);
    }
  };

const fetchMessagesCB = (
  dispatch: any,
  chatId: string,
  currentUser: any,
  agentRole: string
) => {
  dispatch(
    loadChats({
      chatId: chatId
    })
  );
  if (currentUser?.type === agentRole) {
    const promise1 = new Promise((resolve, reject) => {
      dispatch(
        loadChatConfigurations({
          chatId: chatId,
          resolve: resolve,
          reject: reject
        })
      );
    });

    const promise2 = new Promise((resolve, reject) => {
      dispatch(
        loadBusinessHoursChatPermission({
          chatId: chatId,
          resolve: resolve,
          reject: reject
        })
      );
    });

    Promise.all([promise1, promise2])
      .then((data: any) => {
        const lockCondition =
          data[1].optStatus === false ||
          //(data[1].userMessaged === false) || this condition is not required by canned messages
          data[1].isAllowedToChatPerOfficeHoursConfig === false ||
          data[0].template === 0;

        if (lockCondition) {
          const messsage = { type: "hideSlider" };
          window.parent.postMessage(messsage);
        }
      })
      .catch(() => {
        // console.log('error in fetcgMessage config');
      });
  }
};

export default socket;
